import { CommonModule, UpperCasePipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ScheduleEvent } from '../../models/ScheduleModels';
import { TranslatePipe } from '@ngx-translate/core';

export interface EventDetailsDialogResult {
  action?: 'delete';
  eventId?: string;
}

@Component({
  selector: 'app-event-details-dialog',
  templateUrl: './event-details-dialog.component.html',
  styleUrls: ['./event-details-dialog.component.css'],
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, TranslatePipe, UpperCasePipe],
})
export class EventDetailsDialogComponent  {

  

  constructor(
    public dialogRef: MatDialogRef<EventDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ScheduleEvent,
  ) {}

  

  close(): void {
    this.dialogRef.close();
  }

  onDelete(): void {
    this.dialogRef.close({ action: 'delete', eventId: this.data.EventId } as EventDetailsDialogResult);
  }
}
